import { useMemo } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { usePages } from 'api/portal/usePagesApi';

import AcSelect from 'components/AcSelect/AcSelect';
import { cn } from 'components/lib/utils';
import { UILabel } from 'components/ui';

interface IPagesSelectProps {
  onOptionChange: (value: string[]) => void;
  value: string[];
  isRequired?: boolean;
  label?: string;
  isHorizontal?: boolean;
  className?: string;
}

export const PagesSelect: React.FC<IPagesSelectProps> = ({
  onOptionChange,
  value,
  isRequired = false,
  label,
  isHorizontal,
  className
}) => {
  const { getPages } = usePages();
  const pagesData = getPages?.data?.pages;

  const pagesOptions = useMemo(
    () =>
      pagesData?.map(({ pageName, id }: { pageName: string; id: string }) => ({
        content: pageName,
        key: id,
        value: id
      })),
    [pagesData]
  );

  const handleRenderPagesValue = (selected: any) => {
    // const selectedValues = pagesOptions
    //   .filter((option: any) => selected.includes(option.value))
    //   .map(({ content }: { content: string }) => content);

    const selectedLength = selected?.length;
    const selectedValue = pagesOptions.find(
      (option: any) => option.value === selected[0]
    )?.content;
    if (selectedLength < pagesOptions?.length && selectedLength > 1)
      return 'Multiple pages';
    if (selectedLength === 1) return selectedValue;
    return 'All pages';
  };

  return (
    <div
      className={cn(
        'relative flex w-full',
        isHorizontal
          ? label
            ? 'items-top space-x-4'
            : 'items-top space-x-0'
          : 'flex-col',
        className
      )}
    >
      {label && (
        <UILabel
          htmlFor="select"
          className={cn(
            'flex text-p-s font-medium text-base-foreground mb-2',
            isHorizontal ? 'pt-2' : ''
          )}
        >
          {isRequired && (
            <div className="mr-2 mt-1">
              <FontAwesomeIcon
                icon="fa-regular fa-asterisk"
                className="h-2 w-2 text-[8px]"
              />
            </div>
          )}
          {label}
        </UILabel>
      )}
      <div className="w-full">
        <AcSelect
          items={pagesOptions}
          isCheckBox
          setSelectedItems={onOptionChange}
          value={value || []}
          renderValue={handleRenderPagesValue}
          isApplyBtnEnabled
          isSelectAllEnabled={true}
          selectAllCustomLabel={'All pages'}
        />
      </div>
    </div>
  );
};
